import { useState } from 'react';
import { useDataProvider, useNotify } from "ra-core";
import { Button } from "@mui/material";
import { topActionButtonBaseStyle } from "../Styles";
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import CustomTooltip from '../../utils/CustomTooltip';

export default function DownloadScreeningEvent({ id,
    reportId,
    eventId, showOnlyIcon=false,
    userName, clientId }) {
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const handleDownload = async () => {
        try {
            setLoading(true);

            const { data } = await dataProvider.getScreeningReportEventPdf({
                id,
                reportId,
                eventId,
                clientId
            });

            // decode the text-based representation (base64) back into the original binary data
            const base64Data = data.formattedReportData;
            const byteCharacters = atob(base64Data);
            const byteArrays = [];

            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays.push(byteCharacters.charCodeAt(i));
            }

            const byteArray = new Uint8Array(byteArrays);
            // create a blob object which is the browser's standard way of handling binary file data for downloads
            const blob = new Blob([byteArray]);

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            const userPart = userName ? `-${userName}` : "";
            downloadLink.download = `ScreeningReportEvent${userPart}-${eventId}.pdf`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

        } catch (error) {
            notify('Something went wrong while exporting screening report event as pdf', "warning", { autoHideDuration: 1000 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomTooltip
            title="Export as PDF"
            placement="top"
        >
            <Button
                id={`identity-download-screening-event-${eventId}`}
                sx={{ ...topActionButtonBaseStyle(), fontSize: '13px', height: '33px' }}
                onClick={handleDownload}
                disabled={loading}
                size="large"
            >
                <GetAppOutlinedIcon /> { showOnlyIcon ? '' : (loading ? 'Exporting...' : 'Export as PDF')}
            </Button>
        </CustomTooltip>
    );
}